<div class="new-leads-container">
	<div class="heading">
		<app-page-subtitle title="New Leads"></app-page-subtitle>
	</div>

	<div class="content">
		<app-loading-state [isLoading]="isLoading" [loadedContent]="leadsTable"></app-loading-state>

		<ng-template #leadsTable>
			<div class="table-container">
				<ng-container *ngIf="leads.length; else noNewLeads">
					<ng-container *ngFor="let lead of leads">
						<app-latest-lead-card [lead]="lead"></app-latest-lead-card>
					</ng-container>
				</ng-container>
				<ng-template #noNewLeads>
					<em>No new leads.</em>
				</ng-template>
			</div>
		</ng-template>
	</div>
</div>
